
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn-sql",
      function () {
        return require("private-next-pages/learn-sql/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn-sql"])
      });
    }
  